'use strict'

cookieName = 'ls-cookies-ack'

cookieBanner = ->
  banner = document.getElementById 'ls-cookie-banner'
  return unless banner
  try
    return if localStorage[cookieName]

  closeBanner = ->
    banner.parentNode.removeChild(banner)
    localStorage.setItem cookieName, true
  banner.classList.remove('ls-hide')

  acknowledgeLink = document.getElementById 'ls-accept-cookies'
  acknowledgeLink.addEventListener('click', closeBanner, { once: true })

module.exports = {
  cookieBanner
}



// WEBPACK FOOTER //
// ./modules/cookie_banner/frontend/main.coffee